import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-right-shot',
  templateUrl: './right-shot.component.html',
  styleUrls: ['./right-shot.component.scss']
})
export class RightShotComponent implements OnInit {
  @Input() product: any;
  selectProduct: any;

  banners = 
    {
      midc: [
        {
          link: 'https://midatacredito.com/',
          img:'assets/images/change/logo_midc_w.svg',
          title: 'Midatacrédito',
          h1: 'Bienvenido a Midatacrédito',
          h2: 'Estás a un solo paso de tomar el control de tu vida financiera.',
          sliders:[
            {
              img: 'assets/images/banners/midc/Herramientas_MIDC.svg',
              title: 'Tu tienes el control',
              txt:'Encuentra todas las herramientas para poder tomar el control de tu vida financiera.',
            },
            {
              img: 'assets/images/banners/midc/Seguro_MIDC.svg',
              title: 'Es seguro',
              txt:'Tu registro y autenticación ayudan a evitar el fraude por suplantación.',
            },
            {
              img: 'assets/images/banners/midc/Sincosto_MIDC.svg',
              title: 'Sin costo',
              txt:'Conoce tus reportes en DataCrédito de forma gratuita.',
            }
          ]
        }
      ],
      pntd: [
        {
          link: 'https://pontealdia.midatacredito.com/',
          img:'assets/images/change/logo_pad_blanco_202308.svg',
          title: 'Midatacrédito | Ponte al Día',
          h1: 'Bienvenido a Ponte al Día',
          h2: 'Estás a un solo paso de tomar el control de tu vida financiera.',
          sliders:[
            {
              img: 'assets/images/banners/pntd/descuentos_PAD_fucsia.svg',
              title: 'Grandes descuentos',
              txt:'Recibe ofertas de negociación exclusivas, para Ponerte al Día con tus deudas.',
            },
            {
              img: 'assets/images/banners/pntd/seguridad_PAD_fucsia.svg',
              title: 'Es seguro',
              txt:'Tu registro y autenticación ayudan a evitar el fraude por suplantación en las negociaciones.',
            },
            {
              img: 'assets/images/banners/pntd/sin_costo_PAD_fucsia.svg',
              title: 'Sin costo',
              txt:'Te acompañamos en la negociación de tus deudas.',
            }
          ]
        }
      ],
      bc: [
        {
          link: 'https://buscacredito.midatacredito.com/',
          img:'assets/images/change/logo_bc_blanco_202308.svg',
          title: 'Midatacrédito | BuscaCrédito',
          h1: 'Bienvenido a Buscacrédito',
          h2: 'Estás a un solo paso de tomar el control de tu vida financiera.',
          sliders:[
            {
              img: 'assets/images/banners/bc/Ofertas_para_ti_BC.svg',
              title: 'Ofertas justo para ti',
              txt:'Encuentra en el Marketplace ofertas hechas a tu medida.',
            },
            {
              img: 'assets/images/banners/bc/Es_Seguro_BC.svg',
              title: 'Es seguro',
              txt:'Tu registro y autenticación ayudan a evitar el fraude por suplantación en las negociaciones.',
            },{
              img: 'assets/images/banners/bc/Es_gratis_BC.svg',
              title: 'Sin costo',
              txt:'Te acompañamos mientras encuentras la oferta ideal.',
            }
          ]
        }
      ]
    };

  constructor() { }

  ngOnInit(): void {
    this.selectProduct =this.getProducto()[0];
  }

  getProducto(){
    switch (this.product){
      case "midc":
        return this.banners.midc;
        break;
      case "bc":
        return this.banners.bc;
        break;
      case "pntd":
        return this.banners.pntd;
        break;
      default:
        return this.banners.midc;
        break;
    }
  }

}
